.modal-title {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-between;
  padding: var(--rc-theme-spacing-lg);
  border-bottom: var(--rc-theme-border-base);

  .title {
    margin: 0;
    font-size: var(--rc-theme-font-size-heading-h4);
    font-weight: var(--rc-theme-font-weight-medium);
  }
}
